<template>
  <q-btn
    round
    push
    color="green-14"
    icon="bug_report"
    size="10px"
    :disable="data.seamless"
    @click.stop="makeSnapshot"
  />

  <q-dialog v-model="data.seamless" seamless position="bottom" class="report-dialog">
    <q-card style="width: 350px" class="bg-red-3">
      <q-card-section class="text-center text-white q-my-sm">
        <div class="text-h6">Отчет об ошибке</div>
        <div class="text-subtitle2">
          Поддержка изучит проблему
        </div>
      </q-card-section>
      <q-card-section class="report-dialog__section flex" id="snapshot">
        <q-img
          :src="data.src"
          width="60%"
          height="60%"
          style="border-radius: 0.25rem; box-shadow: 12px 12px 2px 1px rgba(0, 0, 255, .2);"
          class="bg-white q-mx-auto"
        ></q-img>
      </q-card-section>
      <q-card-section class="q-mt-md">
        <div class="text-caption text-center text-white">
          <span>
            <q-icon
              size="16px"
              name="error"
              color="primary"
              class="q-ml-md q-my-auto"
            />
            Снимок экрана может иметь погрешности
            <q-icon
              size="16px"
              name="error"
              color="primary"
              class="q-mr-md q-my-auto"
            />
            <br />
            в положении прокрутки страницы и стилистике

          </span>
        </div>
        <q-input
          color="white"
          class="light-form q-mx-md q-mb-sm"
          v-model="data.text"
          filled
          clearable
          autogrow
          autofocus
          label='Место, чтобы пожаловаться'
          hint='Подробно опишите проблему, с которой столкнулись'
          type="text"
        />
        <q-btn-group spread>
          <q-btn
            text-color="white"
            icon="send"
            label="Отправить"
            @click="sendBugReport"
          />
          <q-btn
            text-color="white"
            icon="cancel"
            label="Отменить"
            @click="cancelReport"
          />
        </q-btn-group>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script lang="ts">
import { PropType, reactive } from 'vue';
import * as Pico from '@gripeless/pico';
import { useQuasar } from 'quasar';
import { useMainStore } from '@/store';

export default { name: 'BugReport' };
</script>

<script setup lang="ts">
const $q = useQuasar();
$q.loadingBar.setDefaults({
  color: 'teal',
  size: '5px',
  position: 'top',
});

const data = reactive({
  seamless: false,
  src: '' as any,
  text: '',
});

const cancelReport = () => {
  data.text = '';
  data.src = '';
  data.seamless = false;
};

const makeSnapshot = async () => {
  useMainStore().reportMode = true;
  let screenshot = (await Pico.objectURL(window)).value;
  screenshot = (await Pico.objectURL(window)).value;
  data.src = screenshot;
  useMainStore().reportMode = false;
  data.seamless = true;
};

const sendBugReport = async () => {
  $q.loadingBar.start();
  await useMainStore().sendBugReport({
    file: data.src,
    text: data.text,
  });
  cancelReport();
  $q.loadingBar.stop();
};
</script>

<style>

</style>
